import { DynamicValue } from "@faedev/dynamic-values";
import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import { Col, Form } from "react-bootstrap";
import FormSelect from "src/components/FormSelect";
import Heading from "src/components/Heading";
import MqPhone from "src/components/MqPhone";
import Text from "src/components/Text";
import Translate from "src/components/Translate";
import gutter from "src/functions/gutter";
import onChangeToValue from "src/functions/onChangeToValue";
import optionsContact from "src/functions/optionsContact";
import { sFormControl } from "src/styles/sFormControl.module.scss";
import { sFormJoinUsContact } from "src/styles/sFormJoinUsContact.module.scss";
import { sFormLabel } from "src/styles/sFormLabel.module.scss";

type Props = {
  item: number;
  className?: (string | string) | null | undefined;
  style?: CSSProperties | null | undefined;
  formDataContactType: DynamicValue<string | undefined>;
  formDataContactValue: DynamicValue<string | undefined>;
};

function FormJoinUsContact({
  item,
  className,
  style,
  formDataContactType,
  formDataContactValue,
}: Props) {
  const { locale: lang } = useRouter();
  return (
    <div
      className={composeClassNames([
        sFormJoinUsContact,
        className,
        "joinus-contact",
      ])}
      style={style}
    >
      <MqPhone>
        <Heading
          type={`h5`}
          title={
            <>
              <Translate tKey={`Direct contact`} />
              {` `}
              {String(item)}
            </>
          }
        />
      </MqPhone>
      <Form.Row style={gutter(`margin`, `bottom`, `xn`)}>
        <Col sm={4} xs={12}>
          <Form.Group>
            <MqPhone>
              <Form.Label className={sFormLabel}>
                <Text size={`nm`}>
                  <Translate tKey={`Contact type`} />
                </Text>
              </Form.Label>
            </MqPhone>
            <FormSelect
              as={`select`}
              options={optionsContact(lang)}
              className={sFormControl}
              name={`contact-type-` + String(item)}
              id={`contact-type-` + String(item)}
              onChange={function (param2) {
                return formDataContactType.change(onChangeToValue(param2));
              }}
              value={formDataContactType.value}
            />
          </Form.Group>
        </Col>
        <Col sm={4} xs={12}>
          <Form.Group>
            <MqPhone>
              <Form.Label className={sFormLabel}>
                <Text size={`nm`}>
                  <Translate tKey={`Contact information`} />
                </Text>
              </Form.Label>
            </MqPhone>
            <Form.Control
              className={sFormControl}
              name={`contact-value-` + String(item)}
              id={`contact-value-` + String(item)}
              onChange={function (param2) {
                return formDataContactValue.change(onChangeToValue(param2));
              }}
              value={formDataContactValue.value}
            />
          </Form.Group>
        </Col>
      </Form.Row>
    </div>
  );
}

export default FormJoinUsContact;
